var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSunrise(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.06191 17.0001H2.00001C1.44773 17.0001 1.00001 17.4478 1.00001 18.0001C1.00001 18.5524 1.44773 19.0001 2.00001 19.0001H22C22.5523 19.0001 23 18.5524 23 18.0001C23 17.4478 22.5523 17.0001 22 17.0001H19.9381C19.446 13.0538 16.0796 10.0001 12 10.0001C7.9204 10.0001 4.55401 13.0538 4.06191 17.0001ZM6.08297 17.0001H17.9171C17.441 14.1624 14.973 12.0001 12 12.0001C9.02702 12.0001 6.55905 14.1624 6.08297 17.0001Z",
    fill: "#FFC93E"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.8015 11.4018C23.1319 11.8444 23.0409 12.471 22.5984 12.8013L21.2585 13.8015C20.816 14.1318 20.1894 14.0409 19.859 13.5983C19.5286 13.1557 19.6196 12.5291 20.0622 12.1988L21.402 11.1986C21.8445 10.8683 22.4711 10.9592 22.8015 11.4018Z",
    fill: "#FFC93E"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.5982 7.19861C19.0408 7.52896 19.1317 8.15555 18.8014 8.59815L17.8014 9.93793C17.4711 10.3805 16.8445 10.4715 16.4019 10.1412C15.9593 9.81082 15.8683 9.18423 16.1986 8.74163L17.1986 7.40185C17.529 6.95926 18.1556 6.86827 18.5982 7.19861Z",
    fill: "#FFC93E"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 5C12.5523 5 13 5.44772 13 6V8C13 8.55228 12.5523 9 12 9C11.4477 9 11 8.55228 11 8V6C11 5.44772 11.4477 5 12 5Z",
    fill: "#FFC93E"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.40177 7.19867C5.84435 6.8683 6.47095 6.95927 6.80131 7.40185L7.80138 8.7416C8.13174 9.18418 8.04077 9.81078 7.59819 10.1411C7.15561 10.4715 6.52902 10.3805 6.19865 9.93796L5.19859 8.59821C4.86822 8.15563 4.95919 7.52904 5.40177 7.19867Z",
    fill: "#FFC93E"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.19871 11.4018C1.52909 10.9592 2.15569 10.8683 2.59826 11.1986L3.93787 12.1987C4.38044 12.529 4.4714 13.1556 4.14102 13.5982C3.81064 14.0408 3.18404 14.1317 2.74147 13.8013L1.40186 12.8013C0.959289 12.471 0.868337 11.8444 1.19871 11.4018Z",
    fill: "#FFC93E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSunrise);
export default __webpack_public_path__ + "static/media/sunrise.18d8a3964896bb796f84ac51fa4c7a79.svg";
export { ForwardRef as ReactComponent };